import { getApiCall, postApiCall } from "../../utils/request";
import { returnErrors } from "../errorAction";
import { GET_CONTENT_LIST, GET_NEXT_CONTENT_LIST, APPROVED, RESET_CONTENT,CHANGE_CONTENT_STATUS } from '../../actionType/type';

export const getContentList = (page, type) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/users/content?page=${page}&type=${type}`);
        dispatch({ type: GET_CONTENT_LIST, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getNextContentList = (page, type) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/users/content?page=${page}&type=${type}`);
        dispatch({ type: GET_NEXT_CONTENT_LIST, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const approveContent = (type, _id, review) => async (dispatch) => {
    const approve = {
        type, _id, review
    }
    try {
        const response = await postApiCall(`admin/users/content/update/review`, approve);
        dispatch({ type: APPROVED, payload: approve });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const resetContent = () => async (dispatch) => {

    return dispatch({ type: RESET_CONTENT });
}


export const changeContentStatus = (id, checked) => async (dispatch) => {
    const obj = {
        _id: id,
    };
    try {
        const response = await postApiCall(`admin/users/content/update/activate`, obj);
        dispatch({ type: CHANGE_CONTENT_STATUS, payload: { id, checked } });
        if (!checked) {
            returnErrors(
                dispatch,
                "Content has been successfully deactivated",
                200
            );
        }
        else {
            returnErrors(
                dispatch,
                "Content has been successfully activated",
                200
            );
        }
    } catch (error) {
        returnErrors(
            dispatch,
            error.response !== undefined && error.response.data.message,
            error.response !== undefined && error.response.status
        );
    }
}